export const ROWS_PER_PAGE_OPTIONS = [10, 50, 100, 500, 1000, 5000, 8000, 10000];
export const DEFAULT_ROWS_PER_PAGE = 10;
export const MAX_ROWS_PER_PAGE = 5000;
